import { useState, useEffect } from 'react';
import { HostBackend } from '../../Routes/HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { FilterUnivers } from '../../Components/Public/Filters/FilterUnivers.js';
import { FilterCategory } from '../../Components/Public/Filters/FilterCategory.js';
import { FilterAttractions } from '../../Components/Public/Filters/FilterAttractions.js';
import { CarrouselDatas } from '../../Components/Public/Carrousel/CarrouselDatas.js';
import { GetDescription } from '../../Components/Public/Functions/GetDescription.js';
import { ScrollTop } from '../../Components/Public/Functions/ScrollTop.js';
/* document */
import { Navigation } from '../../Components/Public/Document/Navigation.js';
import { Header } from '../../Components/Public/Document/Header.js';
import { Footer } from '../../Components/Public/Document/Footer.js';
import { BreadCrumb } from '../../Components/Public/Document/Breadcrumb.js';
import { Carrousel } from '../../Components/Public/Carrousel/Carrousel.js';
import { BlockLogoParksAndUnivers } from '../../Components/Public/Logos/BlockLogoParksAndUnivers.js';
import { BlockCollection } from '../../Components/Public/Blocks/BlockCollection.js';
import { BlockTitleDate1Link1 } from '../../Components/Public/Blocks/BlockTitleDate1Link1.js';
import { BlockOutlink } from '../../Components/Public/Blocks/BlockOutlink.js';
import { BackTop } from '../../Components/Public/Document/BackTop.js';
import { AnimCarrousel } from '../../Components/Public/Functions/AnimCarrousel.js';

export const Univers = (props) => {
    const { navParks, att, id } = props;
    const backend = HostBackend();
    const guest = sessionStorage.getItem('guest');
    const [body, setBody] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const bodyDatas = await fetch(`${backend}/univers/body?id=${id}`, GetHeaders(guest));
            const body = await bodyDatas.json();
            setBody(body);
        };
        fetchData();
        ScrollTop();
        AnimCarrousel();
    }, [backend, id, guest]);
    const univers = FilterUnivers(navParks, id)
    const attractions = FilterAttractions('univers', att, id);
    const categories = FilterCategory('univers', att, id);
    const carrouselDatas = CarrouselDatas('univers', attractions);
    const carrouselTotal = attractions.length;
    const items = GetDescription('univers', { body: body, attractions: attractions });
    return (
        <div className="univers">
            <Navigation navParks={navParks} />
            <Header />
            <Carrousel label="univers" datas={carrouselDatas} total={carrouselTotal} />
            <BreadCrumb label="univers" />
            <section className="infos">
                <div className="bloc-infos">
                    <BlockLogoParksAndUnivers label="univers" item={univers} />
                    <BlockCollection label="categories" datas={categories} att={attractions} />
                    <BlockCollection label="univers" datas={attractions} />
                </div>
                <div className="description">
                    <BlockTitleDate1Link1 label="univers" items={items} />
                    <p>{items.description}</p>
                    <BlockOutlink items={items} />
                </div>
            </section>
            <BackTop />
            <Footer />
        </div>
    )
}